<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="企业名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入企业名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:company:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" >-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:company:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
        <a-button type="primary" @click="handleExport" >
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <div slot="logo" slot-scope="text, record" v-if="record.logo">
          <div style="display: flex;flex-wrap: wrap;width: 175px">
            <img v-image-preview style="width: 80px;height: 80px;margin-right: 5px;margin-bottom: 5px" :src="item" :key="index" v-for="(item,index) in record.logo.split(',')"/>
          </div>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a @click="openDetail(record)">详情</a>
          <a-divider type="vertical" v-if="record.status == 0" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.status == 0">
            <a-icon type="edit" />审核
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <AuditDetailCompany ref="AuditDetailCompany"/>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCompany,listCompany, delCompany } from '@/api/user/company'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import AuditDetailCompany from './modules/AuditDetailCompany'

export default {
  name: 'Company',
  components: {
    CreateForm,
    AuditDetailCompany
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        usci: null,
        iegalName: null,
        status: null,
        logo: null,
        industryName: null,
        city: null,
        introduction: null,
        webUrl: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '企业名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'usci',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '法人姓名',
          dataIndex: 'iegalName',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: 'logo',
        //   dataIndex: 'logo',
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: { customRender: 'logo' }
        // },
        // {
        //   title: '行业名称',
        //   dataIndex: 'industryName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '认证状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: function (status) {
            if(status == 0) {
              return '待认证'
            } else if(status == 1) {
              return '认证成功'
            } else if(status == 2) {
              return '认证失败'
            }
          }
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    openDetail(record) {
      this.$refs['AuditDetailCompany'].handleOpen(record)
    },
    /** 查询企业信息列表 */
    getList () {
      this.loading = true
     pageCompany(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        usci: undefined,
        iegalName: undefined,
        status: undefined,
        logo: undefined,
        industryName: undefined,
        city: undefined,
        introduction: undefined,
        webUrl: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCompany(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/company/export', {
            ...that.queryParam
          }, `企业信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
